import React from 'react';
import { GQL } from '@gin-betting/core';

import { convertNameToRuLocale } from 'utils';
import TeamLogo from '../TeamLogo';

import './logoTitle.scss';

interface Props {
    name: string | null;
    logoUrl: string;
    competitorType: GQL.CompetitorType;
    isServer: boolean;
}

const LogoTitle: React.FC<Props> = ({
    name,
    logoUrl,
    competitorType,
    isServer,
}) => {
    const convertedName = convertNameToRuLocale(name);

    return (
        <div styleName="wrapper" className="__app-LogoTitle-link">
            <TeamLogo
                competitorType={competitorType}
                logoUrl={logoUrl}
                isServer={isServer}
            />
            <div
                styleName="name"
                className="__app-LogoTitle-name"
                title={convertedName}
            >
                {convertedName}
            </div>
        </div>
    );
};

export default LogoTitle;
